import React, { Component, Dispatch } from 'react';

import { Common } from '../../core/common';
import { IAction, IAppState } from '../../models/action/core';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Input as InputReact, Modal } from 'reactstrap';
import { IMainMenuProps } from '../../models/pages/main-menu';
import { connect as reduxConnect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import { GetSendTwoFactorVerificationMail } from '../../store/actions/background';
import { checkVerificationCode, clickExternalLogin, clickLoginForm, SetTwoFactorMethodError } from '../../store/actions/login';
import { UserType } from '../../models/enums/userType';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
export class TwoFactorVerification extends Component<any> {
    timer: any;
    public state = {
        codeScreenStatus: false,
        timeLeft: 120,   // second
        twoFactorCode: '',
        twoFactorVerificationError: ''
    }
    public constructor(props: any) {
        super(props);
        _common = new Common();

        this.timer = null;
    }

    componentDidMount(): void {
        this.startCountdown();
    }
    componentWillUnmount() {
        clearInterval(this.timer);
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: any, snapshot?: any): void {
        if(this.props.twoFactorVerificationError?.length > 0 ){
            this.setState({twoFactorVerificationError: this.props.twoFactorVerificationError, timeLeft: 0}, 
                this.props.dispatch(SetTwoFactorMethodError('')))
        }
    }
    
    startCountdown = () => {
        this.timer = setInterval(() => {
            this.setState((prevState: any) => {
                if (prevState.timeLeft <= 0) {
                    clearInterval(this.timer);
                    return { timeLeft: 0 };
                }
                return { timeLeft: prevState.timeLeft - 1 };
            });
        }, 1000);
    };

    formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`;
    };

    resendVerificationCode = () => {
        this.setState({ timeLeft: 120, twoFactorVerificationError: '' }, this.startCountdown)
        this.props.dispatch(GetSendTwoFactorVerificationMail(this.props.twoFactorEmail, false, "GetSendTwoFactorVerificationMail"))
    };

    checkVerificationCodeCallback = () => {
        if (this.props.loginFormData.isExternal) {
            this.props.dispatch(clickExternalLogin(this.props.loginFormData.loginToken!, '', 'get'));
        } else {
            this.props.dispatch(clickLoginForm(this.props.loginFormData.username, this.props.loginFormData.password, this.props.loginFormData.loginCulture, this.props.loginFormData.googleCaptchaToken, 'LoginFormSubmitLoading', 'get'));
        }
    }

    login = () => {
        this.props.dispatch(checkVerificationCode(true, this.props.twoFactorEmail, this.state.twoFactorCode, "checkVerificationCode", "get", this.checkVerificationCodeCallback))
        this.props.dispatch(SetTwoFactorMethodError(''))
    }

    public render() {
        let redirectRoot;
        let url = this.props.isAlmsPlusLoginPage ? window.appSettings.DEFAULT_URL : window.appSettings.DEFAULT_URL + '/u/Home/Cockpit';
        if (this.props.isLogin) {
            redirectRoot = <Redirect to={this.props.userType !== UserType.Admin ? window.appSettings.DEFAULT_URL + '/u/Home/Index' : url} />;
        }
        const { timeLeft, twoFactorCode } = this.state;
        return (
            redirectRoot ??
            <Modal
                className="pt-0"
                style={{ maxWidth: '450px', margin: '0 auto', marginTop: "50px", height: "100%" }}
                isOpen={true}
                fade={true}
                backdrop={'static'}>
                <div className="white-box" style={{ padding: "15px", height: "100%" }}>

                    <div className='d-flex justify-content-center white-box-header'>
                        <img className="navbar-image" src={this.props.organizationLogo} onError={_common.OnErrorImageSrc} data-imgtype={'main'} />
                    </div>


                    <div style={{ paddingBottom: "10px" }} className='d-flex white-box-header'>
                        <h2>
                            {T.t('r_add_two_factor_code_verification')}
                        </h2>
                    </div>

                    <div style={{ paddingTop: "0px", paddingBottom: "40px" }} className="d-flex justify-content-between white-box-header" dangerouslySetInnerHTML={{ __html: T.t('r_add_two_factor_code_verification_info').replace("{email}", this.props.twoFactorEmail) }}>
                    </div>
                    <div >
                        <div className='d-flex'>
                            <div className='col-md-12'>
                                <InputReact
                                    type={'text'}
                                    name={'twoFactorCode'}
                                    placeHolder={T.t('r_add_two_factor_code_enter')}
                                    style={{ borderTop: "0px", borderRight: "0px", borderLeft: "0px" }}
                                    onBlur={(e: any) => {
                                        const value = e.target.value;
                                        this.setState({ twoFactorCode: value });
                                    }}
                                    onClickCapture={() => this.setState({twoFactorVerificationError: ''})}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className="d-flex flex-column align-items-center"
                        style={{
                            marginTop: "40px",
                            paddingBottom: "10px",
                        }}
                    >
                        {this.state.twoFactorVerificationError?.length > 0 && (
                            <span style={{ color: "red", marginBottom: "10px" }}>
                                {this.state.twoFactorVerificationError}
                            </span>
                        )}
                        <button
                            style={{
                                backgroundColor: "transparent",
                                border: "none",
                                color: "#5e84ca",
                                textDecoration: "underline",
                                cursor: timeLeft > 0 ? "not-allowed" : "pointer",
                                fontWeight: "normal",
                                opacity: timeLeft > 0 ? 0.5 : 1,
                                textUnderlinePosition: "under"
                            }}
                            disabled={timeLeft > 0}
                            onClick={() => {
                                if (timeLeft === 0) {
                                    this.resendVerificationCode()
                                }
                            }}
                        >
                            <span style={{ textDecoration: "none" }}>
                                {T.t("r_add_two_factor_code_resend")}
                            </span>
                            {timeLeft > 0 && (
                                <span>
                                    &nbsp;({this.formatTime(timeLeft)})
                                </span>
                            )}
                        </button>
                    </div>
                    <div></div>
                    <div className="social-footer" style={{ marginTop: "60px" }}>
                        <div className="activity-footer d-flex justify-content-between">
                            <div className="mini-btn">
                                {/* tslint:disable-next-line */}
                                <button onClick={() => window.history.back()} type="button" className="btn btn-gray min-auto">{T.t('r_cancel_button')}</button>
                            </div>
                            <div className="mini-btn text-md-right">
                                {/* tslint:disable-next-line */}
                                <button disabled={twoFactorCode.length < 6} onClick={() => this.login()} type="button" className="btn btn-green min-auto"> {T.t('r_gen_login')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IMainMenuProps): IMainMenuProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IMainMenuProps = Object.assign({}, ownProps, {
        organizationLogo: state.login.login.organizationLogo,
        twoFactorEmail: state.login.login.twoFactorEmail,
        loginFormData: state.login.loginData,
        isLogin: state.login.identitiy.isLogin,
        twoFactorVerificationError: state.login.twoFactorVerificationError
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = next.mainMenuRoot.mainMenu === prev.mainMenuRoot.mainMenu &&
        next.login.login === prev.login.login &&
        next.login.loginData === prev.login.loginData &&
        next.login.twoFactorVerificationError === prev.login.twoFactorVerificationError &&
        next.login.identitiy.organizationId === prev.login.identitiy.organizationId &&
        next.login.identitiy.isLogin === prev.login.identitiy.isLogin &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.iFrame.iFrameSource === prev.iFrame.iFrameSource &&
        next.message.mainMenuMessageUnread === prev.message.mainMenuMessageUnread &&
        next.announcement.mainMenuAnnouncementUnread === prev.announcement.mainMenuAnnouncementUnread &&
        next.message.unreadMessageCount === prev.message.unreadMessageCount &&
        next.announcement.unreadAnnounceCount === prev.announcement.unreadAnnounceCount;
    return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const CTwoFactorVerification = reduxConnect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual
    }
)(TwoFactorVerification);

export default withRouter(CTwoFactorVerification);
